import * as _ from 'lodash'
import {IGraphAxis, IGraphMetric, IGraphMetricComponent, IGraphAxisRenderOptions, IGraphMetricRenderOptions, IGraphMetricComponentRenderOptions} from "./PA.UIM.Graph.IF";
import {IPeriod, IPeriodMetrics} from "./PA.UIM.Metric.IF";
import {IMetrics} from "../PA.Metric.Services/PA.Metrics.IF";

let mtrc: IMetrics = undefined
let pm: IPeriodMetrics = undefined

//
// Define Metrics for each Axis
//

//<editor-fold desc="Consumer Units Axis">

//<editor-fold desc="Consumer Units Axis - Metrics">

const CNSMP_INCR_UNITS_UseBounds: IGraphMetric = {
  id: "CNSMP_INCR_UNITS_UseBounds",
  name: "Incremental Units",
  sort: 10,
  renderOptions: {},
  components: [
    {id: "CNSMP_INCR_UNITS_InsideBounds",
     name: "InsideBounds Incr Units",
     metricFieldName: "CNSMP_INCR_UNITS",
     periodMetricsPath: "InsideBounds",
     renderOptions: {ui5: { dataShape: "bar",
                            dataPointRule: {
                               dataContext: {"CNSMP_INCR_UNITS_InsideBounds": '*'},
                               properties: {color : "#CBF4C9"},
                               displayName: "InsideBounds Incr Units"
                            }
                          }
                    }
    },
    {id: "CNSMP_INCR_UNITS_OutsideBounds",
      name: "OutsideBounds Incr Units",
      metricFieldName: "CNSMP_INCR_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
                             dataPointRule: {
                               dataContext: {"CNSMP_INCR_UNITS_OutsideBounds": '*'},
                               properties: {color : "#CBF4C9",  pattern : "diagonalLightStripe"},
                               displayName: "OutsideBounds Incr Units"
                             }
                           }
                     }
    }
  ]
}


const CNSMP_EDLP_UNITS_UseBounds: IGraphMetric = {
  id: "CNSMP_EDLP_UNITS_UseBounds",
  name: "EDLP Units",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "CNSMP_EDLP_UNITS_InsideBounds",
      name: "InsideBounds EDLP Units",
      metricFieldName: "CNSMP_EDLP_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_EDLP_UNITS_InsideBounds": '*'},
            properties: {color : "#0080FF"},
            displayName: "InsideBounds EDLP Units"
          }
        }
      }
    },
    {id: "CNSMP_EDLP_UNITS_OutsideBounds",
      name: "OutsideBounds EDLP Units",
      metricFieldName: "CNSMP_EDLP_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_EDLP_UNITS_OutsideBounds": '*'},
            properties: {color : "#0080FF",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds EDLP Units"
          }
        }
      }
    }
  ]
}


const CNSMP_BASE_UNITS_UseBounds: IGraphMetric = {
  id: "CNSMP_BASE_UNITS_UseBounds",
  name: "True Base Units",
  sort: 40,
  renderOptions: {},
  components: [
    {id: "CNSMP_BASE_UNITS_InsideBounds",
      name: "InsideBounds Base Units",
      metricFieldName: "CNSMP_BASE_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_BASE_UNITS_InsideBounds": '*'},
            properties: {color : "#A59487"},
            displayName: "InsideBounds Base Units"
          }
        }
      }
    },
    {id: "CNSMP_BASE_UNITS_OutsideBounds",
      name: "OutsideBounds Base Units",
      metricFieldName: "CNSMP_BASE_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_BASE_UNITS_OutsideBounds": '*'},
            properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Base Units"
          }
        }
      }
    }
  ]
}


const CNSMP_SYND_BASE_UNITS_UseBounds: IGraphMetric = {
  id: "CNSMP_SYND_BASE_UNITS_UseBounds",
  name: "Synd Base Units",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "CNSMP_SYND_BASE_UNITS_InsideBounds",
      name: "InsideBounds Synd Base Units",
      metricFieldName: "CNSMP_SYND_BASE_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_SYND_BASE_UNITS_InsideBounds": '*'},
            properties: {color : "#A59487"},
            displayName: "InsideBounds Synd Base Units"
          }
        }
      }
    },
    {id: "CNSMP_SYND_BASE_UNITS_OutsideBounds",
      name: "OutsideBounds Synd Base Units",
      metricFieldName: "CNSMP_SYND_BASE_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_SYND_BASE_UNITS_OutsideBounds": '*'},
            properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Synd Base Units"
          }
        }
      }
    }
  ]
}

//</editor-fold>

export const  StdUnitsAxis: IGraphAxis = {
  id: "Units",
  name: "Consumer Units",
  renderOptions: {ui5: {
                    resourceName: "StandardConsumerUnitsAxisName",
                    vizPropertiesAxis: {
                      title: {
                        visible: true,
                        text: "Consumer Units"
                      }
                    },
                    vizPropertiesPlotArea: {}
                 }
  },
  metrics: [CNSMP_INCR_UNITS_UseBounds, CNSMP_EDLP_UNITS_UseBounds, CNSMP_BASE_UNITS_UseBounds, CNSMP_SYND_BASE_UNITS_UseBounds],
  defaultRenderedMetricIds: [
    CNSMP_INCR_UNITS_UseBounds.id,
    CNSMP_EDLP_UNITS_UseBounds.id,
    CNSMP_BASE_UNITS_UseBounds.id
  ]


}

//</editor-fold>

//<editor-fold desc="Price Axis">

//<editor-fold desc="Price Axis - Metrics">

export const CNSMP_RETAILER_BASE_PRICE: IGraphMetric = {
  id: "CNSMP_RETAILER_BASE_PRICE",
  name: "Base Price",
  sort: 200,
  renderOptions: {},
  components: [
    {id: "CNSMP_RETAILER_BASE_PRICE",
      name: "Base Price",
      metricFieldName: "RETAILER_BASE_PRICE",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"CNSMP_RETAILER_BASE_PRICE": '*'},
            properties: {color : "#A59487", lineColor : "#A59487", lineType : "line"},
            displayName: "Base Price"
          }
        }
      }
    }
  ]
}

export const CNSMP_RETAILER_PROMOTED_PRICE: IGraphMetric = {
  id: "CNSMP_RETAILER_PROMOTED_PRICE",
  name: "Promoted Price",
  sort: 220,
  renderOptions: {},
  components: [
    {id: "CNSMP_RETAILER_PROMOTED_PRICE",
      name: "Promoted Price",
      metricFieldName: "RETAILER_PROMOTED_PRICE",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"CNSMP_RETAILER_PROMOTED_PRICE": '*'},
            properties: {color : "#CBF4C9", lineColor : "#CBF4C9", lineType : "line"},
            displayName: "Promoted Price"
          }
        }
      }
    }
  ]
}

export const CNSMP_RETAILER_AVG_PRICE: IGraphMetric = {
  id: "CNSMP_RETAILER_AVG_PRICE",
  name: "Average Price",
  sort: 240,
  renderOptions: {},
  components: [
    {id: "CNSMP_RETAILER_AVG_PRICE",
      name: "Average Price",
      metricFieldName: "RETAILER_AVG_PRICE",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"CNSMP_RETAILER_AVG_PRICE": '*'},
            properties: {color : "#0080FF", lineColor : "#0080FF", lineType : "line"},
            displayName: "Average Price"
          }
        }
      }
    }
  ]
}

export const CNSMP_LIST_PRICE: IGraphMetric = {
  id: "CNSMP_LIST_PRICE",
  name: "List Price",
  sort: 260,
  renderOptions: {ui5: {resourceName: "mtrcListPrice"}},
  components: [
    {id: "CNSMP_LIST_PRICE",
      name: "List Price",
      metricFieldName: "LIST_PRICE",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"CNSMP_LIST_PRICE": '*'},
            properties: {color : "#91FFBA", lineColor : "#91FFBA", lineType : "line"},
            displayName: "List Price"
          }
        }
      }
    }
  ]
}

//</editor-fold>

export const StdPricesAxis: IGraphAxis = {
  id: "Prices",
  name: "Prices",
  renderOptions: {ui5: {
    resourceName: "StandardPricesAxisName",
      vizPropertiesAxis: {
        label : {
          formatString: "0.00"
        },
        title: {
          visible: true,
          text: "Price"
        }
      },
      vizPropertiesPlotArea: {
        "line": {"marker": {"shape": "diamond"}}
      }
    }},
  metrics: [CNSMP_RETAILER_BASE_PRICE, CNSMP_RETAILER_PROMOTED_PRICE, CNSMP_RETAILER_AVG_PRICE, CNSMP_LIST_PRICE],
  defaultRenderedMetricIds: [
    CNSMP_RETAILER_BASE_PRICE.id,
    CNSMP_RETAILER_PROMOTED_PRICE.id,
    CNSMP_RETAILER_AVG_PRICE.id]

}

//</editor-fold>


//<editor-fold desc="Merchandising Units Axis">


//<editor-fold desc="Merchandising Units Axis - Metrics">

//mtrc.MERCH_FEATUREDISPLAY_UNITS
const MERCH_FEATUREDISPLAY_UNITS_UseBounds: IGraphMetric = {
  id: "MERCH_FEATUREDISPLAY_UNITS_UseBounds",
  name: "F&D Units",
  sort: 5,
  renderOptions: {},
  components: [
    {id: "MERCH_FEATUREDISPLAY_UNITS_InsideBounds",
      name: "InsideBounds F&D Units",
      metricFieldName: "MERCH_FEATUREDISPLAY_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREDISPLAY_UNITS_InsideBounds": '*'},
            properties: {color : "#B03BB2"},
            displayName: "InsideBounds F&D Units"
          }
        }
      }
    },
    {id: "MERCH_FEATUREDISPLAY_UNITS_OutsideBounds",
      name: "OutsideBounds F&D Units",
      metricFieldName: "MERCH_FEATUREDISPLAY_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREDISPLAY_UNITS_OutsideBounds": '*'},
            properties: {color : "#B03BB2",  pattern : "diagonalStripe"},
            displayName: "OutsideBounds F&D Units"
          }
        }
      }
    }
  ]
}

//mtrc.MERCH_FEATUREONLY_UNITS
const MERCH_FEATUREONLY_UNITS_UseBounds: IGraphMetric = {
  id: "MERCH_FEATUREONLY_UNITS_UseBounds",
  name: "Feat Units",
  sort: 7,
  renderOptions: {},
  components: [
    {id: "MERCH_FEATUREONLY_UNITS_InsideBounds",
      name: "InsideBounds Feat Units",
      metricFieldName: "MERCH_FEATUREONLY_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREONLY_UNITS_InsideBounds": '*'},
            properties: {color : "#7CFF9F"},
            displayName: "InsideBounds Feat Units"
          }
        }
      }
    },
    {id: "MERCH_FEATUREONLY_UNITS_OutsideBounds",
      name: "OutsideBounds Feat Units",
      metricFieldName: "MERCH_FEATUREONLY_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREONLY_UNITS_OutsideBounds": '*'},
            properties: {color : "#7CFF9F",  pattern : "diagonalStripe"},
            displayName: "OutsideBounds Feat Units"
          }
        }
      }
    }
  ]
}

//mtrc.MERCH_DISPLAYONLY_UNITS
const MERCH_DISPLAYONLY_UNITS_UseBounds: IGraphMetric = {
  id: "MERCH_DISPLAYONLY_UNITS_UseBounds",
  name: "Disp Units",
  sort: 9,
  renderOptions: {},
  components: [
    {id: "MERCH_DISPLAYONLY_UNITS_InsideBounds",
      name: "InsideBounds Disp Units",
      metricFieldName: "MERCH_DISPLAYONLY_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_DISPLAYONLY_UNITS_InsideBounds": '*'},
            properties: {color : "#0092B2"},
            displayName: "InsideBounds Disp Units"
          }
        }
      }
    },
    {id: "MERCH_DISPLAYONLY_UNITS_OutsideBounds",
      name: "OutsideBounds Disp Units",
      metricFieldName: "MERCH_DISPLAYONLY_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_DISPLAYONLY_UNITS_OutsideBounds": '*'},
            properties: {color : "#0092B2",  pattern : "diagonalStripe"},
            displayName: "OutsideBounds Disp Units"
          }
        }
      }
    }
  ]
}

//mtrc.MERCH_TPRONLY_UNITS
const MERCH_TPRONLY_UNITS_UseBounds: IGraphMetric = {
  id: "MERCH_TPRONLY_UNITS_UseBounds",
  name: "TPR Units",
  sort: 10,
  renderOptions: {},
  components: [
    {id: "MERCH_TPRONLY_UNITS_InsideBounds",
      name: "InsideBounds TPR Units",
      metricFieldName: "MERCH_TPRONLY_UNITS",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_TPRONLY_UNITS_InsideBounds": '*'},
            properties: {color : "#FF7800"},
            displayName: "InsideBounds TPR Units"
          }
        }
      }
    },
    {id: "MERCH_TPRONLY_UNITS_OutsideBounds",
      name: "OutsideBounds TPR Units",
      metricFieldName: "MERCH_TPRONLY_UNITS",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_TPRONLY_UNITS_OutsideBounds": '*'},
            properties: {color : "#FF7800",  pattern : "diagonalStripe"},
            displayName: "OutsideBounds TPR Units"
          }
        }
      }
    }
  ]
}


//</editor-fold>


export const StdMerchadisingUnitsAxis: IGraphAxis = {
  id: "MerchandisingUnits",
  name: "Merchadising Units",
  renderOptions: {ui5: {
    resourceName: "StandardMerchandisingUnitsAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Merch Units"
        }
      },
      vizPropertiesPlotArea: {

      }
    }},
  metrics: [
    MERCH_FEATUREDISPLAY_UNITS_UseBounds,
    MERCH_FEATUREONLY_UNITS_UseBounds,
    MERCH_DISPLAYONLY_UNITS_UseBounds,
    MERCH_TPRONLY_UNITS_UseBounds
  ],
  defaultRenderedMetricIds: [
    MERCH_FEATUREDISPLAY_UNITS_UseBounds.id,
    MERCH_FEATUREONLY_UNITS_UseBounds.id,
    MERCH_DISPLAYONLY_UNITS_UseBounds.id,
    MERCH_TPRONLY_UNITS_UseBounds.id
  ]

}

//</editor-fold>

//<editor-fold desc="Merchandising ACV Axis">

//<editor-fold desc="Merchandising ACV Axis - Metrics">


//mtrc.MERCH_FEATUREDISPLAY_ACV_PCNT Bounds
export const MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds: IGraphMetric = {
  id: "MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds",
  name: "F&D ACV",
  sort: 5,
  renderOptions: {},
  components: [
    {id: "MERCH_FEATUREDISPLAY_ACV_PCNT_InsideBounds",
      name: "InsideBounds F&D ACV",
      metricFieldName: "MERCH_FEATUREDISPLAY_ACV_PCNT",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREDISPLAY_ACV_PCNT_InsideBounds": '*'},
            properties: {color : "#B03BB2", lineColor : "#B03BB2", lineType : "line" },
            displayName: "InsideBounds F&D ACV"
          }
        }
      }
    },
    {id: "MERCH_FEATUREDISPLAY_ACV_PCNT_OutsideBounds",
      name: "OutsideBounds F&D ACV",
      metricFieldName: "MERCH_FEATUREDISPLAY_ACV_PCNT",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREDISPLAY_ACV_PCNT_OutsideBounds": '*'},
            properties: {color : "#B03BB2", lineColor : "#B03BB2", lineType : "line", pattern : "noFill" },
            displayName: "OutsideBounds F&D ACV"
          }
        }
      }
    }
  ]
}

//mtrc.MERCH_FEATUREONLY_ACV_PCNT Bounds
const MERCH_FEATUREONLY_ACV_PCNT_UseBounds: IGraphMetric = {
  id: "MERCH_FEATUREONLY_ACV_PCNT_UseBounds",
  name: "Feat ACV",
  sort: 6,
  renderOptions: {},
  components: [
    {id: "MERCH_FEATUREONLY_ACV_PCNT_InsideBounds",
      name: "InsideBounds Feat ACV",
      metricFieldName: "MERCH_FEATUREONLY_ACV_PCNT",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREONLY_ACV_PCNT_InsideBounds": '*'},
            properties: {color : "#7CFF9F", lineColor : "#7CFF9F", lineType : "line" },
            displayName: "InsideBounds Feat ACV"
          }
        }
      }
    },
    {id: "MERCH_FEATUREONLY_ACV_PCNT_OutsideBounds",
      name: "OutsideBounds Feat ACV",
      metricFieldName: "MERCH_FEATUREONLY_ACV_PCNT",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREONLY_ACV_PCNT_OutsideBounds": '*'},
            properties: {color : "#7CFF9F", lineColor : "#7CFF9F", lineType : "line", pattern : "noFill" },
            displayName: "OutsideBounds Feat ACV"
          }
        }
      }
    }
  ]
}


//mtrc.MERCH_DISPLAYONLY_ACV_PCNT Bounds
const MERCH_DISPLAYONLY_ACV_PCNT_UseBounds: IGraphMetric = {
  id: "MERCH_DISPLAYONLY_ACV_PCNT_UseBounds",
  name: "Disp ACV",
  sort: 7,
  renderOptions: {},
  components: [
    {id: "MERCH_DISPLAYONLY_ACV_PCNT_InsideBounds",
      name: "InsideBounds Disp ACV",
      metricFieldName: "MERCH_DISPLAYONLY_ACV_PCNT",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_DISPLAYONLY_ACV_PCNT_InsideBounds": '*'},
            properties: {color : "#0092B2", lineColor : "#0092B2", lineType : "line" },
            displayName: "InsideBounds Disp ACV"
          }
        }
      }
    },
    {id: "MERCH_DISPLAYONLY_ACV_PCNT_OutsideBounds",
      name: "OutsideBounds Disp ACV",
      metricFieldName: "MERCH_DISPLAYONLY_ACV_PCNT",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_DISPLAYONLY_ACV_PCNT_OutsideBounds": '*'},
            properties: {color : "#0092B2", lineColor : "#0092B2", lineType : "line", pattern : "noFill" },
            displayName: "OutsideBounds Disp ACV"
          }
        }
      }
    }
  ]
}


//mtrc.MERCH_TPRONLY_ACV_PCNT Bounds
const MERCH_TPRONLY_ACV_PCNT_UseBounds: IGraphMetric = {
  id: "MERCH_TPRONLY_ACV_PCNT_UseBounds",
  name: "TPR ACV",
  sort: 8,
  renderOptions: {},
  components: [
    {id: "MERCH_TPRONLY_ACV_PCNT_InsideBounds",
      name: "InsideBounds TPR ACV",
      metricFieldName: "MERCH_TPRONLY_ACV_PCNT",
      periodMetricsPath: "InsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_TPRONLY_ACV_PCNT_InsideBounds": '*'},
            properties: {color : "#FF7800", lineColor : "#FF7800", lineType : "line" },
            displayName: "InsideBounds TPR ACV"
          }
        }
      }
    },
    {id: "MERCH_TPRONLY_ACV_PCNT_OutsideBounds",
      name: "OutsideBounds TPR ACV",
      metricFieldName: "MERCH_TPRONLY_ACV_PCNT",
      periodMetricsPath: "OutsideBounds",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"MERCH_TPRONLY_ACV_PCNT_OutsideBounds": '*'},
            properties: {color : "#FF7800", lineColor : "#FF7800", lineType : "line", pattern : "noFill" },
            displayName: "OutsideBounds TPR ACV"
          }
        }
      }
    }
  ]
}




//</editor-fold>


export const StdMerchadisingACVAxis: IGraphAxis = {
  id: "MerchandisingACV",
  name: "Merchadising ACV",
  renderOptions: {
    ui5: {
      resourceName: "StandardMerchandisingACVAxisName",
      vizPropertiesAxis: {
        label : {
          formatString : "0\\%"
        },
        title: {
          visible: true,
          text: "ACV"
        }
      },
      vizPropertiesPlotArea: {
        "line" : { "marker" : {"shape": "diamond"}, visible : false}
      }
    }
  },
  metrics: [
    MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds,
    MERCH_FEATUREONLY_ACV_PCNT_UseBounds,
    MERCH_DISPLAYONLY_ACV_PCNT_UseBounds,
    MERCH_TPRONLY_ACV_PCNT_UseBounds
  ],
  defaultRenderedMetricIds: [
    MERCH_FEATUREDISPLAY_ACV_PCNT_UseBounds.id,
    MERCH_FEATUREONLY_ACV_PCNT_UseBounds.id,
    MERCH_DISPLAYONLY_ACV_PCNT_UseBounds.id,
    MERCH_TPRONLY_ACV_PCNT_UseBounds.id
  ]

}



//</editor-fold>

//<editor-fold desc="Merchandising ACV Axis - Bar">

//<editor-fold desc="Merchandising ACV Axis - Metrics - Bar">
//mtrc.MERCH_FEATUREDISPLAY_ACV_PCNT
export const MERCH_FEATUREDISPLAY_ACV_PCNT: IGraphMetric = {
  id: "MERCH_FEATUREDISPLAY_ACV_PCNT",
  name: "F&D ACV",
  sort: 5,
  renderOptions: {},
  components: [
    {id: "MERCH_FEATUREDISPLAY_ACV_PCNT",
      name: "F&D ACV",
      metricFieldName: "MERCH_FEATUREDISPLAY_ACV_PCNT",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREDISPLAY_ACV_PCNT": '*'},
            properties: {color : "#B03BB2"},
            displayName: "F&D ACV"
          }
        }
      }
    }
  ]
}

//mtrc.MERCH_FEATUREONLY_ACV_PCNT
const MERCH_FEATUREONLY_ACV_PCNT: IGraphMetric = {
  id: "MERCH_FEATUREONLY_ACV_PCNT",
  name: "Feat ACV",
  sort: 6,
  renderOptions: {},
  components: [
    {id: "MERCH_FEATUREONLY_ACV_PCNT",
      name: "Feat ACV",
      metricFieldName: "MERCH_FEATUREONLY_ACV_PCNT",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_FEATUREONLY_ACV_PCNT": '*'},
            properties: {color : "#7CFF9F"},
            displayName: "Feat ACV"
          }
        }
      }
    }
  ]
}


//mtrc.MERCH_DISPLAYONLY_ACV_PCNT
const MERCH_DISPLAYONLY_ACV_PCNT: IGraphMetric = {
  id: "MERCH_DISPLAYONLY_ACV_PCNT",
  name: "Disp ACV",
  sort: 7,
  renderOptions: {},
  components: [
    {id: "MERCH_DISPLAYONLY_ACV_PCNT",
      name: "Disp ACV",
      metricFieldName: "MERCH_DISPLAYONLY_ACV_PCNT",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_DISPLAYONLY_ACV_PCNT": '*'},
            properties: {color : "#0092B2"},
            displayName: "Disp ACV"
          }
        }
      }
    }
  ]
}


//mtrc.MERCH_TPRONLY_ACV_PCNT
const MERCH_TPRONLY_ACV_PCNT: IGraphMetric = {
  id: "MERCH_TPRONLY_ACV_PCNT",
  name: "TPR ACV",
  sort: 8,
  renderOptions: {},
  components: [
    {id: "MERCH_TPRONLY_ACV_PCNT",
      name: "TPR ACV",
      metricFieldName: "MERCH_TPRONLY_ACV_PCNT",
      periodMetricsPath: "Total",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"MERCH_TPRONLY_ACV_PCNT": '*'},
            properties: {color : "#FF7800"},
            displayName: "TPR ACV"
          }
        }
      }
    }
  ]
}

//</editor-fold>

export const StdMerchadisingACVAxis_Bars: IGraphAxis = {
  id: "MerchandisingACVBar",
  name: "Merchadising ACV (Bar)",
  renderOptions: {
    ui5: {
      resourceName: "StandardMerchandisingACVAxisName",
      vizPropertiesAxis: {
        label : {
          formatString : "0\\%"
        },
        title: {
          visible: true,
          text: "ACV"
        }
      },
      vizPropertiesPlotArea: {
      }
    }
  },
  metrics: [
    MERCH_FEATUREDISPLAY_ACV_PCNT,
    MERCH_FEATUREONLY_ACV_PCNT,
    MERCH_DISPLAYONLY_ACV_PCNT,
    MERCH_TPRONLY_ACV_PCNT
  ],
  defaultRenderedMetricIds: [
    MERCH_FEATUREDISPLAY_ACV_PCNT.id,
    MERCH_FEATUREONLY_ACV_PCNT.id,
    MERCH_DISPLAYONLY_ACV_PCNT.id,
    MERCH_TPRONLY_ACV_PCNT.id
  ]

}

//</editor-fold>

//<editor-fold desc="Retail Sales Axis">

//<editor-fold desc="Retail Sales Axis - Metrics">

const CNSMP_INCR_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_RTLSLS_UseBounds",
    name: "Incremental Retail Sales",
    sort: 10,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_RTLSLS_InsideBounds",
            name: "InsideBounds Incr Retail Sales",
            metricFieldName: "CNSMP_INCR_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_RTLSLS_InsideBounds": '*'},
                        properties: {color : "#CBF4C9"},
                        displayName: "InsideBounds Incr Retail Sales"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_RTLSLS_OutsideBounds",
            name: "OutsideBounds Incr Retail Sales",
            metricFieldName: "CNSMP_INCR_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_RTLSLS_OutsideBounds": '*'},
                        properties: {color : "#CBF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Incr Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_RTLSLS_UseBounds",
    name: "EDLP Retail Sales",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_EDLP_RTLSLS_InsideBounds",
            name: "InsideBounds EDLP Retail Sales",
            metricFieldName: "CNSMP_EDLP_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_RTLSLS_InsideBounds": '*'},
                        properties: {color : "#0080FF"},
                        displayName: "InsideBounds EDLP Retail Sales"
                    }
                }
            }
        },
        {id: "CNSMP_EDLP_RTLSLS_OutsideBounds",
            name: "OutsideBounds EDLP Retail Sales",
            metricFieldName: "CNSMP_EDLP_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_RTLSLS_OutsideBounds": '*'},
                        properties: {color : "#0080FF",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds EDLP Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_RTLSLS_UseBounds",
    name: "True Base Retail Sales",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_RTLSLS_InsideBounds",
            name: "InsideBounds Base Retail Sales",
            metricFieldName: "CNSMP_BASE_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_RTLSLS_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base Retail Sales"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_RTLSLS_OutsideBounds",
            name: "OutsideBounds Base Retail Sales",
            metricFieldName: "CNSMP_BASE_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_RTLSLS_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_RTLSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_RTLSLS_UseBounds",
    name: "Synd Base Retail Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_SYND_BASE_RTLSLS_InsideBounds",
            name: "InsideBounds Synd Base Retail Sales",
            metricFieldName: "CNSMP_SYND_BASE_RTLSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_RTLSLS_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Synd Base Retail Sales"
                    }
                }
            }
        },
        {id: "CNSMP_SYND_BASE_RTLSLS_OutsideBounds",
            name: "OutsideBounds Synd Base Retail Sales",
            metricFieldName: "CNSMP_SYND_BASE_RTLSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_RTLSLS_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Synd Base Retail Sales"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const  StdRtlSlsAxis: IGraphAxis = {
    id: "RtlSls",
    name: "Retail Sales",
    renderOptions: {ui5: {
            resourceName: "StandardRetailSalesAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Retail Sales"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_RTLSLS_UseBounds, CNSMP_EDLP_RTLSLS_UseBounds, CNSMP_BASE_RTLSLS_UseBounds, CNSMP_SYND_BASE_RTLSLS_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_RTLSLS_UseBounds.id,
        CNSMP_EDLP_RTLSLS_UseBounds.id,
        CNSMP_BASE_RTLSLS_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="List Sales Axis">

//<editor-fold desc="List Sales Axis - Metrics">

const CNSMP_INCR_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_LISTSLS_UseBounds",
    name: "Incremental List Sales",
    sort: 10,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_LISTSLS_InsideBounds",
            name: "InsideBounds Incr List Sales",
            metricFieldName: "CNSMP_INCR_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_LISTSLS_InsideBounds": '*'},
                        properties: {color : "#CBF4C9"},
                        displayName: "InsideBounds Incr List Sales"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_LISTSLS_OutsideBounds",
            name: "OutsideBounds Incr List Sales",
            metricFieldName: "CNSMP_INCR_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_LISTSLS_OutsideBounds": '*'},
                        properties: {color : "#CBF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Incr List Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_LISTSLS_UseBounds",
    name: "EDLP List Sales",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_EDLP_LISTSLS_InsideBounds",
            name: "InsideBounds EDLP List Sales",
            metricFieldName: "CNSMP_EDLP_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_LISTSLS_InsideBounds": '*'},
                        properties: {color : "#0080FF"},
                        displayName: "InsideBounds EDLP List Sales"
                    }
                }
            }
        },
        {id: "CNSMP_EDLP_LISTSLS_OutsideBounds",
            name: "OutsideBounds EDLP List Sales",
            metricFieldName: "CNSMP_EDLP_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_LISTSLS_OutsideBounds": '*'},
                        properties: {color : "#0080FF",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds EDLP List Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_RTLSLS_UseBounds",
    name: "True Base List Sales",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_LISTSLS_InsideBounds",
            name: "InsideBounds Base List Sales",
            metricFieldName: "CNSMP_BASE_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_LISTSLS_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base List Sales"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_LISTSLS_OutsideBounds",
            name: "OutsideBounds Base List Sales",
            metricFieldName: "CNSMP_BASE_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_LISTSLS_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base List Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_LISTSLS_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_LISTSLS_UseBounds",
    name: "Synd Base List Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_SYND_BASE_LISTSLS_InsideBounds",
            name: "InsideBounds Synd Base List Sales",
            metricFieldName: "CNSMP_SYND_BASE_LISTSLS",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_LISTSLS_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Synd Base List Sales"
                    }
                }
            }
        },
        {id: "CNSMP_SYND_BASE_LISTSLS_OutsideBounds",
            name: "OutsideBounds Synd Base List Sales",
            metricFieldName: "CNSMP_SYND_BASE_LISTSLS",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_LISTSLS_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Synd Base List SalesS"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const  StdListSlsAxis: IGraphAxis = {
    id: "ListSls",
    name: "List Sales",
    renderOptions: {ui5: {
            resourceName: "StandardListSalesAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "List Sales"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_LISTSLS_UseBounds, CNSMP_EDLP_LISTSLS_UseBounds, CNSMP_BASE_LISTSLS_UseBounds, CNSMP_SYND_BASE_LISTSLS_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_LISTSLS_UseBounds.id,
        CNSMP_EDLP_LISTSLS_UseBounds.id,
        CNSMP_BASE_LISTSLS_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="Weight Axis">

//<editor-fold desc="Weight Axis - Metrics">

const CNSMP_INCR_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_WT_UseBounds",
    name: "Incremental Weight",
    sort: 10,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_WT_InsideBounds",
            name: "InsideBounds Incr Weight",
            metricFieldName: "CNSMP_INCR_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_WT_InsideBounds": '*'},
                        properties: {color : "#CBF4C9"},
                        displayName: "InsideBounds Incr Weight"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_WT_OutsideBounds",
            name: "OutsideBounds Incr Weight",
            metricFieldName: "CNSMP_INCR_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_WT_OutsideBounds": '*'},
                        properties: {color : "#CBF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Incr Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_WT_UseBounds",
    name: "EDLP Weight",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_EDLP_WT_InsideBounds",
            name: "InsideBounds EDLP Weight",
            metricFieldName: "CNSMP_EDLP_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_WT_InsideBounds": '*'},
                        properties: {color : "#0080FF"},
                        displayName: "InsideBounds EDLP Weight"
                    }
                }
            }
        },
        {id: "CNSMP_EDLP_WT_OutsideBounds",
            name: "OutsideBounds EDLP Weight",
            metricFieldName: "CNSMP_EDLP_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_WT_OutsideBounds": '*'},
                        properties: {color : "#0080FF",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds EDLP Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_WT_UseBounds",
    name: "True Base Weight",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_WT_InsideBounds",
            name: "InsideBounds Base Weight",
            metricFieldName: "CNSMP_BASE_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_WT_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base Weight"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_WT_OutsideBounds",
            name: "OutsideBounds Base Weight",
            metricFieldName: "CNSMP_BASE_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_WT_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_WT_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_WT_UseBounds",
    name: "Synd Base Weight",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_SYND_BASE_WT_InsideBounds",
            name: "InsideBounds Synd Base Weight",
            metricFieldName: "CNSMP_SYND_BASE_WT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_WT_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Synd Base Weight"
                    }
                }
            }
        },
        {id: "CNSMP_SYND_BASE_WT_OutsideBounds",
            name: "OutsideBounds Synd Base Weight",
            metricFieldName: "CNSMP_SYND_BASE_WT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_WT_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Synd Base Weight"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const  StdWeightAxis: IGraphAxis = {
    id: "Weight",
    name: "Weight",
    renderOptions: {ui5: {
            resourceName: "StandardWeightAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Weight"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_WT_UseBounds, CNSMP_EDLP_WT_UseBounds, CNSMP_BASE_WT_UseBounds, CNSMP_SYND_BASE_WT_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_WT_UseBounds.id,
        CNSMP_EDLP_WT_UseBounds.id,
        CNSMP_BASE_WT_UseBounds.id
    ]


}

//</editor-fold>

//<editor-fold desc="Statistical Case Axis">

//<editor-fold desc="Statistical Case Axis - Metrics">

const CNSMP_INCR_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_INCR_STAT_UseBounds",
    name: "Incremental StatCs",
    sort: 10,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_STAT_InsideBounds",
            name: "InsideBounds Incr StatCs",
            metricFieldName: "CNSMP_INCR_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_STAT_InsideBounds": '*'},
                        properties: {color : "#CBF4C9"},
                        displayName: "InsideBounds Incr StatCs"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_STAT_OutsideBounds",
            name: "OutsideBounds Incr StatCs",
            metricFieldName: "CNSMP_INCR_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_STAT_OutsideBounds": '*'},
                        properties: {color : "#CBF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Incr StatCs"
                    }
                }
            }
        }
    ]
}


const CNSMP_EDLP_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_EDLP_STAT_UseBounds",
    name: "EDLP StatCs",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_EDLP_STAT_InsideBounds",
            name: "InsideBounds EDLP StatCs",
            metricFieldName: "CNSMP_EDLP_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_STAT_InsideBounds": '*'},
                        properties: {color : "#0080FF"},
                        displayName: "InsideBounds EDLP StatCs"
                    }
                }
            }
        },
        {id: "CNSMP_EDLP_STAT_OutsideBounds",
            name: "OutsideBounds EDLP StatCs",
            metricFieldName: "CNSMP_EDLP_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_EDLP_STAT_OutsideBounds": '*'},
                        properties: {color : "#0080FF",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds EDLP StatCs"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_BASE_STAT_UseBounds",
    name: "True Base StatCs",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_STAT_InsideBounds",
            name: "InsideBounds Base StatCs",
            metricFieldName: "CNSMP_BASE_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_STAT_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base StatCs"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_STAT_OutsideBounds",
            name: "OutsideBounds Base StatCs",
            metricFieldName: "CNSMP_BASE_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_STAT_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base StatCs"
                    }
                }
            }
        }
    ]
}


const CNSMP_SYND_BASE_STAT_UseBounds: IGraphMetric = {
    id: "CNSMP_SYND_BASE_STAT_UseBounds",
    name: "Synd Base StatCs",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_SYND_BASE_STAT_InsideBounds",
            name: "InsideBounds Synd Base StatCs",
            metricFieldName: "CNSMP_SYND_BASE_STAT",
            periodMetricsPath: "InsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_STAT_InsideBounds": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Synd Base StatCs"
                    }
                }
            }
        },
        {id: "CNSMP_SYND_BASE_STAT_OutsideBounds",
            name: "OutsideBounds Synd Base StatCs",
            metricFieldName: "CNSMP_SYND_BASE_STAT",
            periodMetricsPath: "OutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_SYND_BASE_STAT_OutsideBounds": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Synd Base StatCs"
                    }
                }
            }
        }
    ]
}

//</editor-fold>

export const  StdStatAxis: IGraphAxis = {
    id: "StatCs",
    name: "Statistical Case",
    renderOptions: {ui5: {
            resourceName: "StandardStatAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Statistical Case"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_INCR_STAT_UseBounds, CNSMP_EDLP_STAT_UseBounds, CNSMP_BASE_STAT_UseBounds, CNSMP_SYND_BASE_STAT_UseBounds],
    defaultRenderedMetricIds: [
        CNSMP_INCR_STAT_UseBounds.id,
        CNSMP_EDLP_STAT_UseBounds.id,
        CNSMP_BASE_STAT_UseBounds.id
    ]


}

//</editor-fold>


export const FullStandardAxisList: IGraphAxis[] = [
  StdUnitsAxis,
  StdPricesAxis,
  StdMerchadisingUnitsAxis,
  StdMerchadisingACVAxis,
  StdRtlSlsAxis,
  StdListSlsAxis,
  StdWeightAxis,
  StdStatAxis
]

